import { SearchFacetData } from 'modules/search/types/SearchFacetData';
import { EMPLOYMENT_TYPE } from 'utils/constants/general/employmentType';

export const employmentTypeFacet = {
  id: 'employmentTypeFacet',
  name: 'jobType',
  title: getText('Job Type'),
  type: 'array',
  options: ['FULL_TIME', 'PART_TIME', 'TEMPORARY', 'CONTRACT'],
  optionTitles: EMPLOYMENT_TYPE,
} as const satisfies SearchFacetData;
